import React from "react";
import { ArrowLeft, Loader2, Send } from "lucide-react";

// AUTO-WA-39: a Stage header bar (same buttons and type as every other page).
const TITLES = {
  create: {
    title: "Create template",
    subtitle: "Build a WhatsApp message template and submit it to Meta for approval.",
  },
  view: { title: "Template", subtitle: "Review your WhatsApp template." },
  edit: { title: "Edit template", subtitle: "Update your WhatsApp template." },
};

const TemplatePageHeader = ({ mode = "create", onBack, onSave, loading = false }) => {
  const { title, subtitle } = TITLES[mode] || TITLES.create;

  return (
    <div className="ws-overlay wa-editor-bar">
      <button type="button" onClick={onBack} className="ws-btn ws-btn--quiet" aria-label="Back to templates">
        <ArrowLeft size={16} />
      </button>
      <div className="ws-grow">
        <div className="ws-eyebrow">Templates</div>
        <h1>{title}</h1>
        <p>{subtitle}</p>
      </div>

      {mode === "create" && (
        <div style={{ display: "flex", gap: 8 }}>
          <button type="button" onClick={onBack} disabled={loading} className="ws-btn ws-btn--quiet">Cancel</button>
          <button type="button" onClick={onSave} disabled={loading} className="ws-btn ws-btn--primary">
            {loading ? <Loader2 size={15} className="ws-spin" /> : <Send size={15} />}
            {loading ? "Submitting…" : "Submit for review"}
          </button>
        </div>
      )}
    </div>
  );
};

export default TemplatePageHeader;
